import Vue from "vue";
import Vuex from "vuex";
import commonStore from "@/store/modules/commonStore";
import error from "@/store/modules/error";
import newsFeed from "@/store/modules/newsFeed";
import cards from "@/store/modules/cards";
import documents from "@/store/modules/documents";
import events from "@/store/modules/events";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  modules: {
    commonStore,
    error,
    newsFeed,
    cards,
    documents,
    events
  }
});
